import dayjs from "dayjs";

/**
 * 时间戳转日期格式化
 * @param {number|string} timestamp - 时间戳
 * @param {string} [type='date'] - 输出类型:
 *   'date' - YYYY-MM-DD
 *   'datetime' - YYYY-MM-DD HH:mm:ss
 *   'time' - HH:mm:ss
 *   'custom' - 自定义格式(需传入format参数)
 * @param {string} [format] - 自定义格式，当type='custom'时必填
 * @param {boolean} [isSecond=false] - 是否为秒级时间戳
 * @returns {string} 格式化后的日期字符串
 */
export function formatTimestamp(
  timestamp,
  type = "date",
  format,
  isSecond = false
) {
  if (!timestamp) return "";

  const ts = isSecond ? Number(timestamp) * 1000 : Number(timestamp);
  const date = dayjs(ts);

  if (!date.isValid()) return "";

  switch (type) {
    case "date":
      return date.format("YYYY-MM-DD");
    case "datetime":
      return date.format("YYYY-MM-DD HH:mm:ss");
    case "time":
      return date.format("HH:mm:ss");
    case "custom":
      return format ? date.format(format) : "";
    default:
      return date.format("YYYY-MM-DD");
  }
}

/**
 * 将接口返回的时间字符串（如 2026-02-04T09:39:22.409+08:00）
 * 格式化为 "MM月DD日 HH:mm"（如 02月04日 09:39）
 * @param {string} dateStr - 接口返回的时间字符串
 * @returns {string} 格式化后的日期字符串
 */
export function formatMonthDayTime(dateStr) {
  if (!dateStr) return "";

  const date = dayjs(dateStr);

  if (!date.isValid()) return "";

  return date.format("MM月DD日 HH:mm");
}
